const getBaseUrl = (): string => {
  // Variável de ambiente tem prioridade
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL
  }

  const hostname = window.location.hostname

  // Desenvolvimento local
  if (hostname === 'localhost' || hostname.startsWith('192.168') || hostname.startsWith('10.')) {
    return 'http://localhost:8001'
  }

  // Desenvolvimento com domínio local
  if (hostname === 'app.sispoli.local') {
    return 'http://api.sispoli.local'
  }

  // Produção
  if (hostname.includes('sispoli.com.br')) {
    return 'https://api.sispoli.com.br'
  }

  return 'http://localhost:8001'
}

export const API_BASE_URL = getBaseUrl()

export const ENDPOINTS = {
  // Auth
  LOGIN: '/v1/auth/login',
  REGISTER: '/v1/auth/register',
  LOGOUT: '/v1/auth/logout',
  ME: '/v1/auth/me',
  REFRESH: '/v1/auth/refresh',
  FORGOT_PASSWORD: '/v1/auth/forgot-password',
  RESET_PASSWORD: '/v1/auth/reset-password',

  // Health
  HEALTH: '/v1/health',

  // Eleitores
  ELEITORES: '/v1/eleitores',
  ELEITOR: '/v1/eleitores/:id',

  // Demandas
  DEMANDAS: '/v1/demandas',
  DEMANDA: '/v1/demandas/:id',

  // Lideranças
  LIDERANCAS: '/v1/liderancas',
  LIDERANCA: '/v1/liderancas/:id',

  // Eventos
  EVENTOS: '/v1/eventos',
  EVENTO: '/v1/eventos/:id',

  // Regiões
  REGIOES: '/v1/regioes',
  REGIAO: '/v1/regioes/:id',

  // Dashboard
  DASHBOARD_STATS: '/v1/dashboard/stats',

  // Usuários
  USERS: '/v1/users',
  USER: '/v1/users/:id',
}

export const GEO_ENDPOINTS = {
  STATES: '/v1/geo/states',
  CITIES: '/v1/geo/states/:stateId/cities',
  CEP: '/v1/geo/cep/:cep',
}

export const ELECTION_ENDPOINTS = {
  ELECTIONS: '/v1/elections',
  ZONES: '/v1/elections/zones',
  ZONE_SECTIONS: '/v1/elections/zones/:zoneId/sections',
  RESULTS_OVERVIEW: '/v1/elections/results/overview',
  RESULTS_TURNOUT: '/v1/elections/results/turnout',
  RESULTS_BY_ZONE: '/v1/elections/results/by-zone',
  RESULTS_BY_NEIGHBORHOOD: '/v1/elections/results/by-neighborhood',
  RESULTS_CANDIDATES: '/v1/elections/results/candidates',
  RESULTS_CANDIDATE: '/v1/elections/results/candidates/:candidateId',
  RESULTS_CANDIDATES_COMPARE: '/v1/elections/results/candidates/compare',
}

export function buildApiUrl(endpoint: string, params?: Record<string, string>): string {
  let url = `${API_BASE_URL}${endpoint}`
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      url = url.replace(`:${key}`, value)
    })
  }
  return url
}
